import type { FC } from 'react';
import { Link } from 'react-router-dom';
// mantine
import { Skeleton } from '@mantine/core';
// icons
import { FolderSync } from 'lucide-react';
// utils
import { useProjectQuery } from '@/services/designer/projects/projects.queries';
import { FF_PROJECTS_V2, useFeatureFlag } from '@/hooks/useFeatureFlag';
import { getProjectName } from '@/modules/Projects/Project.utils';
import { PATHS } from '@/const';

interface ProjectBreadcrumbProps {
    projectId?: string | null;
    isLink?: boolean;
}

const ProjectBreadcrumb: FC<ProjectBreadcrumbProps> = ({
    projectId,
    isLink
}) => {
    const { enabled: isProjectsV2Enabled, isResolved } =
        useFeatureFlag(FF_PROJECTS_V2);

    const {
        data: project,
        isFetching,
        isPending
    } = useProjectQuery(isProjectsV2Enabled, projectId ?? undefined, {
        enabled: isResolved
    });
    if (isFetching || isPending || !projectId) {
        return <Skeleton height={10} mb={2} width={200} />;
    }
    const autoUpdateEnabledBadge = project?.is_auto_update_enabled ? (
        <div className="flex items-center gap-1 text-xs text-green-6 whitespace-nowrap mt-0.5">
            <FolderSync />
            Auto Update Enabled
        </div>
    ) : undefined;
    if (isLink) {
        return (
            <div className="leading-none">
                <Link
                    className="block text-black whitespace-nowrap leading-none"
                    to={`${PATHS.projects}/${projectId}`}
                >
                    {getProjectName(project)}
                </Link>
                {autoUpdateEnabledBadge}
            </div>
        );
    }
    return (
        <div className="leading-none">
            {getProjectName(project)}
            {autoUpdateEnabledBadge}
        </div>
    );
};

export default ProjectBreadcrumb;
